import { useEffect, useRef } from "react";

import { useSetAtom } from "jotai";

import { authValidationStateAtom, userAtom } from "@/atoms/auth.atoms";

import { loadGoScenes } from "@/atoms/goScenes.atoms";

import { loadSceneCatalog } from "@/atoms/sceneCatalog.atoms";

import { HttpError } from "@/services/api";

import authService from "@/services/auth.service";

/**
 * On mount, asks /auth/me whether the HttpOnly session cookie is still
 * valid. Success → populate userAtom (source of truth for routing).
 * 401 → no session: stay logged out (the Login screen renders).
 * Network error → assume valid-but-offline; don't kick the user out.
 *
 * Simplified from guest's useInitialAuthValidation: Eriol Go has no ROM
 * concept, so there is nothing else to validate.
 */

export function useInitialAuthValidation() {
  const setUser = useSetAtom(userAtom);

  const setValidationState = useSetAtom(authValidationStateAtom);

  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;

    ranRef.current = true;

    authService

      .getMe()

      .then((profile) => {
        setUser({
          id: profile.id,

          name: profile.name,

          lastName: profile.lastName,

          email: profile.email,

          avatar: profile.avatar,

          accountType: profile.accountType,

          language: profile.language,

          twoFactorEnabled: profile.twoFactorEnabled,
        });

        if (profile.language) {
          localStorage.setItem("user-language", profile.language);
        }

        setValidationState("valid");

        // Sesión válida (incluye reaperturas de la PWA): hidratar go scenes

        // desde IndexedDB + reconciliar con GET /go/scenes, así el gate de

        // onboarding sabe si el usuario ya eligió diseño.

        void loadGoScenes();

        // Catálogo de escenas desde la DB (surface=mobile) — idempotente.

        void loadSceneCatalog();
      })

      .catch((err) => {
        if (err instanceof HttpError && err.status === 401) {
          // No session — normal logged-out state.

          setUser(null);

          setValidationState("valid");

          return;
        }

        // Backend unreachable: don't block the app, just stay logged out

        // until a retry succeeds.

        setValidationState("valid");

        console.warn("[useInitialAuthValidation] validation skipped:", err);
      });
  }, [setUser, setValidationState]);
}
